<script setup lang="ts">
  import { LoaderCircle as LoaderCircleIcon } from 'lucide-vue-next'
  import { computed, type HTMLAttributes } from 'vue'
  import { cn } from '@/lib/utils'
  import TableCell from './TableCell.vue'
  import TableRow from './TableRow.vue'

  const props = withDefaults(defineProps<{
    class?: HTMLAttributes['class'],
    colspan?: number,
  }>(), {
    colspan: 9999,
  })

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })
</script>

<template>
  <table-row>
    <table-cell
      :class="
        cn(
          'p-4 whitespace-nowrap align-middle text-sm text-gray-500',
          props.class,
        )
      "
      v-bind="delegatedProps">
      <div class="flex items-center justify-center py-10">
        <loader-circle-icon class="size-16 animate-spin text-primary" />
      </div>
    </table-cell>
  </table-row>
</template>
